'use client'

import { createContext, type ReactNode } from 'react'

import { ClubMembershipStatus } from '@/helpers/clubMembership'

/**
 * Server-seeded membership status. `null` means "no provider" — the hook then
 * falls back to pure client-store logic.
 */
export const ClubMembershipContext = createContext<ClubMembershipStatus | null>(null)

export function ClubMembershipProvider({
  value,
  children,
}: {
  value: ClubMembershipStatus
  children: ReactNode
}) {
  return <ClubMembershipContext.Provider value={value}>{children}</ClubMembershipContext.Provider>
}
